import React from 'react'
import _ from 'lodash'

export default function UserNotice ({ prePopulated, firstName }) {
  return <>
    <h4>{prePopulated && firstName ? `Hello ${_.upperFirst(firstName.toLowerCase())}, ` : ''}Before You Begin...</h4>
    {prePopulated ? <>
      <p>Your benefit administrator provided a form with some of the information pre-populated. Information displayed is
        based on what we have in our system. If you feel anything should be updated, please do so and notify your
        benefits
        administrator.</p>
      <p>This application should be completed in one session. For your privacy, information is not saved until
        submission. Please allow approximately 10-15 minutes to step through the online application process.</p>
    </> : <>
      <p>For your privacy, information is not saved until submission. Having the following information prior to
        starting the Evidence of Insurability application will help ensure you may complete the application(s) in
        one sitting.<br />
        <i className='u-fontSmall'>You may need to ask your employer for this information.</i></p>
      <ul>
        <li>Group ID Number</li>
        <li>Your Date of Hire</li>
        <li>Your Current Salary</li>
        <li>Current Coverage Amounts (Including Guaranteed Issue Amounts)</li>
      </ul>
    </>
    }
    <p>If an eligible spouse and/or child(ren) will also be applying for Life and/or Critical Illness/Specified
      Disease coverage, certain
      vital information (including height and weight) and health information will need to be provided. All
      eligible persons seeking coverage will be
      required to electronically sign the Evidence of Insurability form(s).*<br />
      <i className='u-fontSmall'>* Child(ren) signature(s) required if age 18 or older (age 15 or older for residents of
        WA)</i></p>
    <h4>Important Notice</h4>
    <p>
      Your policy requires Evidence of Insurability (EOI) be submitted and approved before coverage is approved for an amount over the Guaranteed Issue (GI) amount or if enrollment occurs more than 31 days after you (or your dependent) are first eligible.  If coverage requires EOI approval, premium and related payroll deductions are limited to the premiums for timely enrolled GI amount of coverage until EOI is submitted and approved.  You and your employer will be contacted once a decision has been reached.
    </p>
    <p>
      If EOI is required, no coverage will take effect until EOI is approved. Your employer should not deduct or submit premiums for the portion of coverage requiring EOI until notice of approval has been received.
    </p>
    <p>
      If you have any questions about whether EOI is required for coverage or has been approved, please call Mutual of Omaha’s Customer Service Team at 1-800-369-3809, Monday – Friday 8:00 AM – 5:00 PM (CT).
    </p>
    <p><strong>Important:</strong> Complete responses to the questions are required to establish insurability.
    </p>
  </>
}